const mapFarmerToERP = (farmer) => {
  const DataComplementary = [];
  const codes = Object.keys(farmer.dcs);
  codes.forEach((code) => {
    DataComplementary.push({
      Code: code,
      Value: farmer.dcs[code],
    });
  });
  const farmerERP = {
    Codigo: farmer.code,
    TipoProveedor: (farmer.code === '') ? localStorage.getItem('tipoProveedor') : '',
    Identificador: farmer.identifier,
    PaisEmisor: farmer.country,
    Nombre: farmer.name,
    Email: farmer.email,
    TelefonoMovil: farmer.phone,
    DatosComplementarios: DataComplementary,
    Direccion: [{
      Nombre: farmer.address.name,
      UsoDireccion: 0, // tipo fiscal
      TipoVia: farmer.address.type,
      NombreVia: farmer.address.name2,
      PaisDireccion: farmer.address.country,
    }],
    ProveedorEmpresa: [{
      Empresa: farmer.CompanyProvider.business,
      TipoIva: farmer.CompanyProvider.VATRate,
      Retención: farmer.CompanyProvider.retention,
      FormaPago: farmer.CompanyProvider.wayToPay,
    }],
  };

  // el método de la api no está gestionando bien las direcciones en la modificación
  if (farmer.sync_status === 0) {
    farmerERP.Direccion = [];
  }

  return farmerERP;
};

const mapERPFarmerToLocal = (farmerERP) => {
  const dcs = {};
  farmerERP.dcs.forEach((dc) => {
    dcs[dc.code] = dc.value;
  });
  const farmer = {
    code: farmerERP.Codigo,
    identifier: farmerERP.Identificador,
    name: farmerERP.Nombre,
    country: farmerERP.PaisEmisor,
    email: farmerERP.Email,
    phone: farmerERP.Numero,
    dcs,
    address: {
      name: farmerERP.NombreDireccion,
      type: farmerERP.TipoVia,
      name2: farmerERP.NombreVia,
      country: farmerERP.PaisDireccion,
    },
    CompanyProvider: {
      business: farmerERP.Empresa,
      VATRate: farmerERP.TipoIva,
      retention: farmerERP.Retencion,
      wayToPay: farmerERP.FormaPago,
    },
    sync_status: 0,
  };

  return farmer;
};

export { mapERPFarmerToLocal, mapFarmerToERP };
